var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"areas"},[_c('el-tabs',{staticClass:"fullHeight",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":_vm.$t('Estado de Inventarios')}},[_c('InventoriesStatusTab')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }